(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/bet-modes/regular-mode.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/bet-modes/regular-mode.js');

'use strict';

const {
  useCallback,
  useContext,
  useEffect,
  useState,
  Fragment
} = React;
const {
  ReactIcon
} = svs.ui;
const {
  ItemsMenu: ReactItemsMenu,
  LinkItem: ReactLinkItem
} = svs.ui.ReactItemsMenu;
const {
  Coupon,
  XpertCoupon,
  Betslip,
  MostPlayed,
  QuinellaOdds,
  PressRatings,
  PixModePicker
} = svs.racing_game.components.play;
const {
  PlayContext
} = svs.racing_game.components.playContext;
const {
  fetchMostPlayed,
  fetchQuinellaOdds,
  fetchPressRatings
} = svs.racing.raceService;
const {
  gameTypeHasSystem,
  gameTypeHasXpert,
  gameTypeHasMostPlayed,
  gameTypeHasQuinellaOdds,
  raceHasGameTypeXpert,
  gameTypeIsExclusiveInOrder,
  gameTypeHasPressRatings
} = svs.racing.common.util;
const {
  raceMoreThanDefined,
  raceOpen,
  raceNoLongerOpen
} = svs.racing.common.statusUtil;
const {
  couponMenuItems,
  gameTypes,
  gameTypeToSubProductId
} = svs.racing.common.constants;
const {
  pixToCoupon
} = svs.racing.raceService.utils;
const {
  RacetrackInfo,
  RaceTips
} = svs.racing_game.components.play;
const {
  EmptyDataView
} = svs.racing.emptyDataView;
const CouponContextProvider = svs.racing_game.components.playContext.CouponContextProvider;
const logger = svs.core.log.getLogger('racing.play.regularmode');
const MOST_PLAYED_NO_DATA = 'För tillfället har vi ingen information om mest spelade för det valda loppet.';
const QUINELLA_ODDS_NO_DATA = 'För tillfället har vi inga odds för det valda loppet.';
const RegularMode = _ref => {
  let {
    selectedItem,
    setSelectedItem,
    isDisabled,
    setPixMode,
    selectedPixMode
  } = _ref;
  const [mostPlayed, setMostPlayed] = useState();
  const [quinellaOdds, setQuinellaOdds] = useState();
  const [pressRatings, setPressRatings] = useState([]);
  const {
    engine,
    race
  } = useContext(PlayContext);
  useEffect(() => {
    if (selectedItem === couponMenuItems.MOST_PLAYED && gameTypeHasMostPlayed(engine.gameType)) {
      fetchMostPlayed(race.raceId, gameTypeToSubProductId[engine.gameType], (err, response) => {
        if (err) {
          logger.info("fetch-mostplayed-error: ".concat(err.error));
          setMostPlayed(undefined);
        } else {
          const mostplayed = response || {};
          setMostPlayed(mostplayed);
        }
      });
    }
  }, [selectedItem, race.raceId, engine.gameType]);
  useEffect(() => {
    if (selectedItem === couponMenuItems.PRESS_RATINGS && gameTypeHasPressRatings(engine.gameType)) {
      fetchPressRatings(race.raceId, (err, response) => {
        if (err) {
          logger.info("fetch-mostplayed-error: ".concat(err.error));
          setPressRatings([]);
        } else {
          const pressRatings = response || [];
          setPressRatings(pressRatings);
        }
      });
    }
  }, [selectedItem, race.raceId, engine.gameType]);
  useEffect(() => {
    if (selectedItem === couponMenuItems.QUINELLA_ODDS) {
      fetchQuinellaOdds(race.raceId, engine.subProductId, (err, response) => {
        if (err) {
          logger.info("fetch-quinellaodds-error: ".concat(err.error));
          setQuinellaOdds(undefined);
        } else {
          const fetchedQuinellaOdds = response || {};
          setQuinellaOdds(fetchedQuinellaOdds);
        }
      });
    }
  }, [selectedItem, race.raceId, engine.subProductId]);
  const handleXpertenFetched = useCallback((newPixData, size) => {
    const couponData = pixToCoupon(engine.systemType, newPixData, size, race.numberOfParticipants);
    if (couponData) {
      engine.actions.trySetData(couponData);
    }
  }, [engine.systemType, engine.actions, race.numberOfParticipants]);
  const getSystemLabel = gameType => {
    let systemLabel;
    switch (gameType) {
      case gameTypes.TOPP2:
      case gameTypes.RX2P:
      case gameTypes.RX2P4:
      case gameTypes.RX3AO:
        systemLabel = 'Utgångshäst';
        break;
      case gameTypes.TOPP5:
      case gameTypes.RX4IO:
      case gameTypes.RX3IOAO:
      case gameTypes.RX2IO:
      default:
        systemLabel = 'System';
        break;
    }
    return systemLabel;
  };
  const getValidMenuItems = () => {
    const validMenuItems = [];

    if (raceOpen(race) || raceNoLongerOpen(race)) {
      const systemLabel = getSystemLabel(engine.gameType);

      const couponItem = {
        id: couponMenuItems.COUPON,
        label: 'Kupong',
        icon: 'enkelrader-tur',
        sort: 0
      };
      const systemItem = {
        id: couponMenuItems.SYSTEM,
        label: systemLabel,
        icon: 'systemspel',
        sort: 1
      };
      const pixItem = {
        id: couponMenuItems.PIX,
        label: 'Fyll i med PIX!',
        icon: 'pix',
        sort: 3
      };
      const quinellaOddsItem = {
        id: couponMenuItems.QUINELLA_ODDS,
        label: 'Odds',
        icon: 'odds',
        sort: 4
      };
      const mostPlayedItem = {
        id: couponMenuItems.MOST_PLAYED,
        label: 'Mest spelade',
        icon: 'most-played',
        sort: 5
      };
      const pressRatingsItem = {
        id: couponMenuItems.PRESS_RATINGS,
        label: 'Speltips',
        icon: 'tips',
        sort: 6
      };
      validMenuItems.push(couponItem);

      if (raceNoLongerOpen(race)) {
        couponItem.label = 'Resultat';

      } else if (raceOpen(race)) {
        if (gameTypeHasSystem(engine.gameType)) {
          validMenuItems.push(systemItem);
        }
        if (gameTypeHasXpert(engine.gameType) && raceHasGameTypeXpert(race, engine.gameType)) {
          validMenuItems.push(pixItem);
        }
        if (gameTypeHasMostPlayed(engine.gameType)) {
          validMenuItems.push(mostPlayedItem);
        }
        if (gameTypeHasQuinellaOdds(engine.gameType)) {
          validMenuItems.push(quinellaOddsItem);
        }
        if (gameTypeHasPressRatings(engine.gameType)) {
          validMenuItems.push(pressRatingsItem);
        }
      }
      validMenuItems.sort((a, b) => a.sort - b.sort);
    }
    return validMenuItems;
  };
  const renderCoupon = selectedView => {
    switch (selectedView) {
      case couponMenuItems.MOST_PLAYED:
        return mostPlayed ? React.createElement(MostPlayed, {
          isExclusiveInOrder: gameTypeIsExclusiveInOrder(engine.gameType),
          mostPlayed: mostPlayed
        }) : React.createElement(EmptyDataView, {
          isFadeIn: true,
          label: MOST_PLAYED_NO_DATA
        });
      case couponMenuItems.QUINELLA_ODDS:
        return quinellaOdds ? React.createElement(QuinellaOdds, {
          numberOfParticipants: race.numberOfParticipants,
          participants: race.participants,
          quinellaOdds: quinellaOdds
        }) : React.createElement(EmptyDataView, {
          isFadeIn: true,
          label: QUINELLA_ODDS_NO_DATA
        });
      case couponMenuItems.PIX:
        return React.createElement(React.Fragment, null, engine.gameType === gameTypes.TOPP5 && React.createElement(PixModePicker, {
          selectedPixMode: selectedPixMode,
          setPixMode: selectedMode => setPixMode(selectedMode)
        }), React.createElement(XpertCoupon, {
          handleXpertenFetched: handleXpertenFetched,
          isDisabled: isDisabled,
          key: engine.gameType
        }), React.createElement(Coupon, {
          isDisabled: isDisabled
        }), raceOpen(race) && React.createElement(Betslip, {
          isDisabled: isDisabled
        }));
      case couponMenuItems.PRESS_RATINGS:
        return React.createElement(PressRatings, {
          pressRatings: pressRatings
        });
      case couponMenuItems.COUPON:
      case couponMenuItems.SYSTEM:
      default:
        return React.createElement(React.Fragment, null, React.createElement(RacetrackInfo, {
          race: race
        }), React.createElement(RaceTips, {
          race: race
        }), React.createElement(Coupon, {
          isDisabled: isDisabled
        }), raceOpen(race) && React.createElement(Betslip, {
          isDisabled: isDisabled
        }));
    }
  };
  const renderMenuItems = () => {
    const validMenuItems = getValidMenuItems();
    return validMenuItems.map(item => React.createElement(Fragment, {
      key: item.id
    }, React.createElement(ReactLinkItem, {
      id: item.id,
      label: item.label,
      onClick: () => {
        if (item.id !== selectedItem) {
          setSelectedItem(item.id);
        }
      },
      selected: item.id === selectedItem,
      width: 102
    }, React.createElement(ReactIcon, {
      icon: item.icon,
      size: "400"
    }))));
  };
  if (race && engine.isReady) {
    return React.createElement(React.Fragment, null, raceMoreThanDefined(race) && React.createElement(ReactItemsMenu, {
      branding: "racing",
      className: "items-menu-racing-coupon ".concat(getValidMenuItems().length <= 1 ? 'hidden' : ''),
      scrollIcons: {
        left: 'caret-left',
        right: 'caret-right'
      },
      useScrollFaders: !svs.core.detect.formfactor.mobile(),
      useScrollHelpers: !svs.core.detect.formfactor.mobile()
    }, renderMenuItems()), React.createElement(CouponContextProvider, null, renderCoupon(selectedItem)));
  }
  return null;
};
svs.racing_game.components.play.RegularMode = RegularMode;

 })(window);